export default "__VITE_ASSET__CRg$yh2r__"